import { useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'

export const PermissoesTelas = () => {
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const verificarPermissoes = () => {
      const telasCarregadas = JSON.parse(localStorage.getItem('telascarregadas') || '{}')
      const authentication = JSON.parse(localStorage.getItem('authentication') || '{}')

      const currentPath = location.pathname
      const telaAtual = obterIdTelaDaURL(currentPath, telasCarregadas)

      if (!telaAtual) {
        return
      }

      const temPermissao = verificarPermissaoTela(telaAtual, authentication?.permissoes_usuario || {})

      if (!temPermissao) {
        const telaInicial = encontrarTelaInicial(authentication?.permissoes_usuario || {})
        if (telaInicial) {
          alert('Você não tem permissão para acessar esta tela. Você será redirecionado para a tela inicial.')
          window.location.href = telasCarregadas[telaInicial].link_menu
        } else {
          navigate('/')
        }
      }
    }

    verificarPermissoes()
  }, [location, navigate])

  const normalizarCaminho = (caminho) => {
    if (caminho === '/') return caminho
    return caminho.replace(/\/+$/, '')
  }

  const obterIdTelaDaURL = (url, telasCarregadas) => {
    const urlNormalizada = normalizarCaminho(url)

    for (const [key, value] of Object.entries(telasCarregadas)) {
      const linkNormalizado = normalizarCaminho(value.link_menu)

      if (urlNormalizada === linkNormalizado) {
        return key
      }
    }

    for (const [key, value] of Object.entries(telasCarregadas)) {
      const linkNormalizado = normalizarCaminho(value.link_menu)

      if (linkNormalizado !== '/' && urlNormalizada.startsWith(linkNormalizado)) {
        return key
      }
    }

    return null
  }

  const verificarPermissaoTela = (idTela, permissoes) => {
    return permissoes[idTela] && permissoes[idTela].consulta === 'S'
  }

  const encontrarTelaInicial = (permissoes) => {
    for (const [id, perm] of Object.entries(permissoes)) {
      console.log('perm', perm, id)
      if (perm?.telainicial === 'S') {
        return id
      }
    }
    return null
  }

  return null
}
